import React from 'react'

const Footer = () => {
  return (
    <div className="footerCon">
    <footer className="wrapper">
      <p>Created By B.N Garg | All Right Reserved</p>
    </footer>
</div>
  )
}

export default Footer